"use client";

import { useEffect } from "react";
import { useTranslations } from "next-intl";

export function usePageTitle(translationKey: string) {
    const t = useTranslations();

    useEffect(() => {
        const title = t(translationKey);
        const fullTitle = title ? `${title} - Voids Portal` : "Voids Portal";
        document.title = fullTitle;
    }, [translationKey, t]);
}
